import { useState } from 'react';
import { Box, Flex, Text, useDisclosure } from '@chakra-ui/react';

import './styles.scss';
import authAxios from '@services/authAxios';
import { TextBold } from '@components/typography';
import OutsideClickHandler from 'react-outside-click-handler';
import { ChevronDownIcon, ExportIcon } from '@assets/icons/index';
import { ConditionalComponent } from '@components/functionComponent';
import { useStateParahub } from '@pages/Parahub/hooks/state/useStateParahub';
import { useSnackbarNotification } from '@store/snackbarNotification';
import { fileDownloader } from '@helpers/utils';

const Export = () => {
    const [exportType, setExportType] = useState(null);
    const { exportListParahub } = useStateParahub();
    const { onChangeSnackbarNotification } = useSnackbarNotification();

    const { isOpen: isOpenExport, onToggle: onToggleExport, onClose: onCloseExport } = useDisclosure();
    const { isOpen: isOpenType, onOpen: onOpenType, onClose: onCloseType } = useDisclosure();

    const disableSelected = exportListParahub.length === 0;

    const handleToggleExport = () => {
        onCloseType();
        onToggleExport();
        setExportType(null);
    };

    const handleSelectType = (type) => {
        if (type === 'selected' && disableSelected) return;
        setExportType(type);
        onOpenType();
    };

    const handleExport = async (format) => {
        const idOnly = exportListParahub.map((d) => d.customer_id);

        const typeSelected = exportType === 'selected';
        const params = typeSelected ? { selected_id: `[${idOnly.join(',')}]`, type: format } : { type: format };

        onChangeSnackbarNotification({
            status: 'info',
            title: 'Proses Download Data',
            description: (
                <Box>
                    Silahkan menunggu, sedang mengunduh{' '}
                    <Box display={'inline'} fontWeight={'700'}>
                        Parahub-Customer{typeSelected ? '-Selected' : ''}.{format}
                    </Box>
                </Box>
            ),
            duration: 3,
        });
        try {
            await fileDownloader({
                url: `/api/v1/parahub-store-config/export/customer-parahub`,
                fileName: `Parahub-Customer${typeSelected ? '-Selected' : ''}.${format}`,
                params,
            });
        } catch (error) {
            onChangeSnackbarNotification({
                status: 'error',
                title: '',
                description: `Gagal mengunduh Parahub-Customer${typeSelected ? '-Selected' : ''}.${format}!`,
                duration: 3,
            });
        } finally {
            handleOutsideClick();
        }
    };

    const handleOutsideClick = () => {
        onCloseType();
        onCloseExport();
        setExportType(null);
    };

    return (
        <OutsideClickHandler onOutsideClick={handleOutsideClick}>
            <Box className="export">
                <Flex className={`button ${isOpenExport ? 'active' : ''}`} onClick={handleToggleExport}>
                    <ExportIcon />
                    <TextBold>Export Data</TextBold>
                    <ChevronDownIcon />
                    <ConditionalComponent statement={!disableSelected}>
                        <Box className="indicator" />
                    </ConditionalComponent>
                </Flex>

                <ConditionalComponent statement={isOpenExport}>
                    <Box className="dropdown options">
                        <Flex
                            className={`item ${exportType === 'all' ? 'active' : ''}`}
                            onClick={() => handleSelectType('all')}
                        >
                            <Text>Export All</Text>
                            <ChevronDownIcon transform="rotate(-90deg)" />
                        </Flex>

                        <Flex
                            className={`item ${exportType === 'selected' ? 'active' : ''} ${
                                disableSelected ? 'disable' : ''
                            }`}
                            onClick={() => handleSelectType('selected')}
                        >
                            <Text>Export Selected</Text>
                            <ChevronDownIcon transform="rotate(-90deg)" />
                        </Flex>
                    </Box>
                </ConditionalComponent>

                <ConditionalComponent statement={isOpenType}>
                    <Box className="dropdown type">
                        {['xlsx', 'csv'].map((format) => (
                            <Flex key={format} className="item" onClick={() => handleExport(format)}>
                                <Text>Export as {format.toUpperCase()}</Text>
                            </Flex>
                        ))}
                    </Box>
                </ConditionalComponent>
            </Box>
        </OutsideClickHandler>
    );
};

export default Export;
